
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/[path]",
      function () {
        return require("private-next-pages/case-study/[path]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/[path]"])
      });
    }
  